import FormattedMessage from 'I18n/components/FormattedMessage';
import { DeleteIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { canDeleteEmail } from 'email-management-lib/refactor/utils/getActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BulkDeleteButton({
  hasBulkWriteAccess,
  onClick,
  selectedCrmEmails,
  unsafeEmailCount,
  user
}) {
  if (!hasBulkWriteAccess) {
    return null;
  }
  const shouldLinkDisabled = selectedCrmEmails.some(email => !canDeleteEmail(email, user)) || unsafeEmailCount > 0;
  const tooltipTitle = unsafeEmailCount > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.table.bulkActions.deleteDisabledTooltipWithUnsafeEmails",
    options: {
      count: unsafeEmailCount
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "email-management.table.bulkActions.deleteDisabledTooltip"
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !shouldLinkDisabled,
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.bulkActions.deleteDisabledTooltipHeader"
    }),
    title: tooltipTitle,
    children: /*#__PURE__*/_jsxs(Link, {
      "data-test-id": "delete-link",
      disabled: shouldLinkDisabled,
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(DeleteIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.bulkActions.delete"
      })]
    })
  });
}
export default BulkDeleteButton;